import { render } from "./ApplicationLogo.vue?vue&type=template&id=6658b39e"
const script = {}

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__